import { render } from "./BaseSelectIcon.vue?vue&type=template&id=df019484&scoped=true"
import script from "./BaseSelectIcon.vue?vue&type=script&lang=js"
export * from "./BaseSelectIcon.vue?vue&type=script&lang=js"

import "./BaseSelectIcon.vue?vue&type=style&index=0&id=df019484&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df019484"]])

export default __exports__